"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "1",
  question: "Will we feel awkward in front of the camera?",
  answer: "Not at all! We understand that being photographed can feel unnatural at first, but we create a relaxed, fun environment that helps you feel comfortable. We'll guide you through natural poses and candid moments, making the experience enjoyable rather than stiff. Most couples tell us they forget the camera is even there after the first few minutes!"
}, {
  id: "2",
  question: "Will you guide us, or do we have to know what to do?",
  answer: "You're never left guessing.\n\nWe gently guide when it's helpful and step back when it's not. Whether it's where to stand during portraits or how to move through the day comfortably, we're there to support without controlling the moment.\n\nYou feel confident, cared for, and never exposed or unsure."
}, {
  id: "5",
  question: "Can we choose our own locations for the shoot?",
  answer: "Absolutely! We love exploring new locations and are happy to shoot at venues that are meaningful to you. We also provide location recommendations based on our experience across Sydney if you need inspiration."
}, {
  id: "6",
  question: "Do you travel outside of Sydney for weddings?",
  answer: "Yes, we are available for destination weddings across Australia and internationally. Travel fees may apply depending on the location, but we're always excited to capture your love story wherever it takes us."
}, {
  id: "7",
  question: "What happens if you're unable to attend our wedding due to an emergency?",
  answer: "While extremely rare, we have a network of trusted photographers and videographers who maintain the same quality standards. We ensure that your wedding is covered no matter what, and we'll inform you immediately if any changes occur."
}, {
  id: "8",
  question: "How many Photos for a 3 hour wedding?",
  answer: "Between 50 - 200 depending on when the three hour hours begin."
}, {
  id: "9",
  question: "What is the 30/5 minute rule for weddings?",
  answer: "The 30/5 minute rule (sometimes written as 30-5 minute rule) is the thought process that a task which takes five minutes on a regular day will take 30 minutes on your beautiful wedding day. That's because wedding days are notoriously busy, no matter how much you've scheduled everything down to the minute in your wedding day spreadsheet."
}, {
  id: "10",
  question: "What is the golden hour at a wedding?",
  answer: "The golden hour occurs when the Sun is low on the horizon, typically an hour after sunrise or an hour before sunset. This is the time when the light is warm, soft, and most importantly, flattering, making it perfect for killer wedding portraits. And thats what we are here for... you!"
}, {
  id: "11",
  question: "What is the best time of day for wedding photos?",
  answer: "You might be familiar with the term \"Golden Hour\" from the above question? This is the sweet spot for photographers to get the best shots of their couples and families. Golden hour happens just after sunrise or just before sunset when the sun is lower in the sky. This sun position makes the surrounding light soft and warm, dare I say, golden..... made just for you!"
}, {
  id: "12",
  question: "What is the hour before the wedding called?",
  answer: "Cocktail hour is an essential and enjoyable part of the wedding celebration. With careful planning and thoughtful details, it can set the perfect tone for the festivities to come. Your wedding is important and that hour before can really set the vibe!"
}, {
  id: "13",
  question: "How do I do wedding photography on a budget?",
  answer: "Go for a smaller wedding, seriously! Not only does it allow you to do more with your budget to make your wedding day more like your dream wedding, but the difference in stress I see on my clients faces on the day is immense!"
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section className="bg-background py-20 px-4 sm:px-6 lg:px-8">
      <div ref={ref} className={`mx-auto max-w-3xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
        <h2 className="font-display text-foreground mb-3 text-center text-4xl font-bold tracking-tight sm:text-5xl">
          Frequently Asked Questions
        </h2>
        <p className="text-muted-foreground mb-12 text-center text-lg">Things Couples Often Ask</p>

        <Accordion type="single" collapsible className="w-full space-y-0">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i}>
              <AccordionTrigger className="text-foreground text-base font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed whitespace-pre-line">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}